import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  height: -webkit-fill-available;
  gap: 20px;
`;

const PageNotFound = () => {
  return (
    <Container>
      <h1>404</h1>
      <p>Page not found...</p>
    </Container>
  )
}

export default PageNotFound;